// extracted by mini-css-extract-plugin
export default {"root":"PlasmicHomepage_root__QG0EX","section":"PlasmicHomepage_section__BY-4f"};